import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ISelectorOption, useStores } from '@trivie/core'
import { Dialog } from '@trivie/ui-web/components/dialogs/dialog'
import { AutocompleteSelector } from '../autocomplete-selector'

export interface AddUsersProps {
  open: boolean
  onClose: () => void
}

export const AddUsersToGroup = observer((props: AddUsersProps) => {
  const { open, onClose } = props
  const { groupStore } = useStores()
  const { addUsers, getAddedGroupUsers, addedGroupUsers } = groupStore
  const [selectedUsers, setSelectedUsers] = useState<ISelectorOption[]>([])
  const [excludeIds, setExcludeIds] = useState<number[]>([])

  useEffect(() => {
    getAddedGroupUsers().then(() => {
      setExcludeIds(addedGroupUsers.map((m: any) => m.id))
    })
  }, [])

  const handleSubmit = () => {
    addUsers({ user_ids: selectedUsers.map((u) => u.id) })
    onClose()
  }

  const handleSelectionChange = (users: ISelectorOption[]) => setSelectedUsers(users)

  return (
    <Dialog
      onCancel={() => {
        setSelectedUsers([])
        onClose()
      }}
      disableConfirm={!selectedUsers.length}
      onConfirm={handleSubmit}
      maxWidth="md"
      onClose={onClose}
      title="Add Users to Group"
      confirmBtnLabel="Add Users"
      aria-labelledby="add users to group"
      open={open}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          width: '100%',
          overflow: 'hidden',
          height: 516,
        }}
      >
        <AutocompleteSelector
          variant="users"
          open
          showAvatar
          filterExcludeIds={excludeIds}
          onSelectionChange={handleSelectionChange}
          style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
        />
      </div>
    </Dialog>
  )
})
